/*eslint-disable*/ export const messages = {
    'Add "{inputValue}"': ['Add "', ["inputValue"], '"'],
    "All items have been removed.": "All items have been removed.",
    "Clear selection": "Clear selection",
    "No results found.": "No results found.",
    "Press Enter to select or deselect an option.": "Press Enter to select or deselect an option.",
    "Select All": "Select All",
    "Selected Items": "Selected Items",
    "Toggle menu": "Toggle menu",
    "listbox contents": "listbox contents",
    "{itemAsString} has been removed.": [["itemAsString"], " has been removed."],
    "{itemAsString} has been selected.": [["itemAsString"], " has been selected."],
    "{resultCount, plural, one {# result is} other {# results are}} available, use up and down arrow keys to navigate. Press Enter key to select.":
        [
            ["resultCount", "plural", { one: ["#", " result is"], other: ["#", " results are"] }],
            " available, use up and down arrow keys to navigate. Press Enter key to select.",
        ],
    "{selectedValue} selected": [["selectedValue"], " selected"],
    "{totalSelectedItems} selected": [["totalSelectedItems"], " selected"],
    "{totalSelectedItems} selected. Deselect all": [["totalSelectedItems"], " selected. Deselect all"],
    "{totalSelectedItems} selected. Select all {totalOptions} items": [
        ["totalSelectedItems"],
        " selected. Select all ",
        ["totalOptions"],
        " items",
    ],
};
